import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["button", "label", "spinner"];

  connect() {
    this.defaultLabel = this.labelTarget.dataset.defaultLabel;
    this.restore = this.restore.bind(this);
    this.restore();
    window.addEventListener("pageshow", this.restore);
    window.addEventListener("pagehide", this.restore);
    document.addEventListener("turbo:before-cache", this.restore);
  }

  disconnect() {
    window.clearTimeout(this.resetTimer);
    window.removeEventListener("pageshow", this.restore);
    window.removeEventListener("pagehide", this.restore);
    document.removeEventListener("turbo:before-cache", this.restore);
  }

  async submit(event) {
    event.preventDefault();
    if (this.buttonTarget.disabled) return;

    this.setLoading();

    try {
      const response = await fetch(this.element.action, {
        method: "POST",
        body: new FormData(this.element),
        headers: { Accept: "application/json" },
        credentials: "same-origin",
      });
      const result = await response.json();

      if (!response.ok)
        throw new Error(result.message || "提交失败，请稍后重试。");

      this.element.reset();
      this.showResult(result.message, true);
    } catch (error) {
      this.showResult(error.message || "网络异常，请稍后重试。", false);
    }
  }

  setLoading() {
    window.clearTimeout(this.resetTimer);
    this.buttonTarget.disabled = true;
    this.buttonTarget.setAttribute("aria-busy", "true");
    this.buttonTarget.classList.add("opacity-80", "cursor-wait");
    this.spinnerTarget.hidden = false;
    this.labelTarget.textContent = "提交中…";
  }

  showResult(message, success) {
    this.spinnerTarget.hidden = true;
    this.buttonTarget.removeAttribute("aria-busy");
    this.buttonTarget.classList.remove(
      "opacity-80",
      "cursor-wait",
      "bg-accent",
      "hover:bg-accent/85",
    );
    this.buttonTarget.classList.add(success ? "bg-green-600" : "bg-red-600");
    this.labelTarget.textContent = message;
    this.resetTimer = window.setTimeout(this.restore, 4000);
  }

  restore() {
    window.clearTimeout(this.resetTimer);
    this.spinnerTarget.hidden = true;
    this.buttonTarget.removeAttribute("aria-busy");
    this.buttonTarget.classList.remove(
      "opacity-80",
      "cursor-wait",
      "bg-green-600",
      "bg-red-600",
    );
    this.buttonTarget.classList.add("bg-accent", "hover:bg-accent/85");
    this.buttonTarget.disabled = false;
    this.labelTarget.textContent = this.defaultLabel;
  }
}
